export default __webpack_public_path__ + "static/media/twitter-login.8bf991cc.svg";